import styles from "./main-app-menu.module.css";
import { UIIcon } from "BEDROCK/components/ui-icon-drawing/ui-icon";
import { UIIconName } from "BEDROCK/components/ui-icon-drawing/ui-icon-type";

interface MainAppMenuButtonProps {
  label: string;
  subtitle?: string;
  iconName?: UIIconName;
  onClick: () => void;
}

export const MenuOption = (props: MainAppMenuButtonProps) => {
  return (
    <button className={styles.menuAction} onClick={props.onClick}>
      {props.iconName && (
        <div style={{ marginRight: '8px' }}>
          <UIIcon iconName={props.iconName} variant="REGULAR" size={20} />
        </div>
      )}
      <div className={styles.labels}>
        {props.label}
        {props.subtitle && (
          <span className={styles.subtitle}>{props.subtitle}</span>
        )}
      </div>
    </button>
  );
};
